module.exports = __webpack_public_path__ + "static/media/kv-landing.20dc514d.png";